import React from 'react';
import styles from './VenueCard.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import Image from '../../../components/Image/Image';
import { useTranslation } from 'react-i18next';

const VenueCard = ({ venue }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const onRestaurantClick = () => {
    history.push({
      pathname: '/venue',
      search: `?showId=${venue.id}`,
    });
  };

  return (
    <div className={styles.card} onClick={() => onRestaurantClick()}>
      <div className='position-relative'>
        <Image src={venue.bannerImageUrl} alt={venue.name} size='MEDIUM' progressive={true} />
        {venue.commission && (
          <div className={styles.commission}>{t('earnUpTo', { commission: venue.commission + '%' })}</div>
        )}
      </div>
      <div className='fw-semibold mt-2'>{venue.name}</div>
    </div>
  );
};

export default VenueCard;
